import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

const SectionPaddingBottom = 3;

export const AdvantagesSectionWrapper = styled.div`
  position: relative;
  z-index: 0;
`;

export const AdvantagesSectionContent = styled.div<{ withPaddingBottom: boolean }>`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1120px;
  margin: auto;
  ${({ withPaddingBottom }) => withPaddingBottom && `padding-bottom: 135px;`}

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    border-bottom: 1px solid ${getColor('GRAY_30')};
    padding-bottom: ${SectionPaddingBottom}px;
  }
`;

export const AdvantagesEggBg = styled.img`
  position: absolute;
  z-index: 0;
  right: 0px;
  top: -340px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const AdvantagesSectionTitle = styled.p`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
  text-align: center;
  margin-top: 80px;
  color: ${getColor('GRAY_70')};
  z-index: 1;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 32px;
    font-size: 24px;
    line-height: 36px;
  }
`;

export const AdvantagesSectionSubtitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-top: 6px;
  color: ${getColor('GRAY_70')};
  z-index: 1;

  @media (max-width: ${TabletWidth}px) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 4px;
  }
`;

export const AdvantagesSectionTable = styled.table`
  width: 100%;
  table-layout: fixed;
  margin-top: 40px;
  border-collapse: collapse;
`;

export const AdvantagesSectionTableBody = styled.tbody`
  position: relative;
  z-index: 1;
`;

export const AdvantagesSectionBlur = styled.div`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    display: block;
  }

  pointer-events: none;
  content: '';
  position: absolute;
  z-index: 1;
  bottom: ${SectionPaddingBottom}px;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient(transparent 0%, ${getColor('DARK_CREAM')} 100%);
`;
